module.exports = __webpack_public_path__ + "static/img/function-6.964475c.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/function-6.png
// module id = Cb7D
// module chunks = 0